<template>
  <div>
    <div :class="{'opened': opened, 'container-sacola bg-white': !isComponent}">
      <div class="fixed-top py-4 py-md-3 bg-white shadow-sm mb-3 d-md-none" v-if="!isComponent">
        <div class="container text-center position-relative">
          <a href="javascript:" class="btn btn-outline-light btn-voltar-round position-absolute" style="left: 12px; top: -9px" aria-label="Voltar" @click="$emit('close')">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <div class="font-weight-bold m-auto">SACOLA</div>
        </div>
      </div>
      <div>
        <loading v-show="load" fullscrean="true"/>
        <div v-if="!load">
          <div v-if="dados.produtos && dados.produtos.length">
            <div class="container" :class="{'container-produtos-sacola': !isComponent}">
              <div class="card mb-2 px-3 py-3" :class="{'bg-light': !isComponent}" v-for="p in dados.produtos">
                <div>
                  <div class="font-weight-bold float-right text-nowrap">
                    <span class="badge badge-success" v-if="p.id_beneficio">Grátis</span>
                    <span class="font-weight-bold tamanho-1" v-else>{{(p.valor * p.quantidade) | valor}}</span>

                  </div>
                  <p class="mb-0 tamanho-1"><b>{{p.quantidade}}x</b> {{p.produto.nome_produto}}</p>
                  <p v-for="d in p.divisoes" class="m-0 pl-1 tamanho-2"> # {{d.nome_produto}}</p>
                  <p v-for="d in p.adicionais" class="m-0 pl-1 tamanho-2">
                    + <b v-show="d.qtd > 1">{{d.qtd}}x</b>
                    {{d.nome_produto}} <span v-show="d.valor > 0"> <b>{{((d.valor * d.qtd) * p.quantidade) | valor}}</b></span>
                  </p>
                  <router-link :to="url + '/promocoes'" class="badge badge-warning text-white mr-2" v-if="p.id_beneficio">
                    <icon name="pontos" size="12" class="mr-1"/> Benefício
                  </router-link>
                  <p class="mb-0 tamanho-2" v-show="p.observacao"><b>Obs:</b> {{p.observacao}}</p>
                  <div class="sacola-restricoes">
                    <produto-consumo :consumo="p.produto.tipo_consumo" :tipo_pedido="dados.tipo_pedido" variant="sacola"/>
                    <produto-modo-pedido :modo-pedido="p.produto.modo_pedido" variant="sacola"/>
                  </div>
                  <div class="sacola-item-acoes mt-1">
                    <button type="button" class="border-0 bg-transparent text-primary p-0" @click="openModalProduto(p)">Editar</button>
                    <button type="button" class="border-0 bg-transparent text-muted p-0" @click="removeItem(p)">Remover</button>
                  </div>
                </div>

              </div>
              <div class="mt-3" :class="{'d-md-none': !isComponent}">
                <button class="btn btn-dark btn-block" @click="goCategorias()">
                  <i class="fa fa-plus mr-1"></i> <b>Adicionar mais itens</b>
                </button>
              </div>
              <div class="my-4" v-if="recomendados.length">
                <h6 class="font-weight-bold mb-2">Peça também</h6>
                <carrosell :slides="recomendados" :small="true" @selProduto="selProduto"/>
              </div>
            </div>
            <div class="container">
              <hr v-if="isComponent">
              <h6 class="font-weight-bold mb-0">Totais</h6>
              <p class="mb-0">
                <span class="float-right font-weight-bold">{{dados.total | valor}}</span>
                Subtotal
              </p>
            </div>
            <div class="btn-enviar add-sacola mt-3" v-if="dados.produtos && dados.produtos.length && !isComponent">
              <a href="javascript:" class="btn btn-primary btn-block btn-bottom" @click="finalizarPedido()">
                <b>Continuar Pedido</b>
              </a>
            </div>
          </div>
          <div class="text-center" style="margin: 32px 0" v-else>
            <div class="py-4 text-primary">
              <icon name="sacola" size="100"/>
            </div>
            <div class="small mb-3">Sua sacola está vazia!</div>
            <div>
              <button type="button" @click="goCategorias()" class="btn btn-outline-primary mb-4">Ver Produtos</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <produto ref="sProduto" :empresa-aberta="true" :is-componente="true"/>

    <modal-bottom :opened="modalProduto" v-if="modalProduto && itemEditar.produto">
      <div class="container">
        <div>
          <h6 class="text-center mt-2 mb-3 font-weight-bold">Editar Produto</h6>
          <div class="mb-3">
            <p class="mb-0 mt-1"><b>{{itemEditar.quantidade}}x</b> - {{itemEditar.produto.nome_produto}}</p>

          </div>
          <div class="card card-quantidade px-2 py-3 mb-4" v-if="!itemEditar.id_beneficio">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="m-0 font-weight-bold">Quantidade</h6>
                <div class="small" v-if="itemEditar.produto.estoque === '1'">
                  <span v-if="itemEditar.produto.qtd_estoque == 1">1 unidade disponível</span>
                  <span v-else-if="itemEditar.produto.qtd_estoque <= 20"><b>{{itemEditar.produto.qtd_estoque | percent}}</b> unidades disponíveis</span>
                </div>
              </div>
              <div style="width: 125px;">
                <quantidade :qtd-inicial="itemEditar.quantidade" @change="(qtd) => { this.itemEditar.quantidade = qtd }" :max="itemEditar.produto.qtd_estoque"/>
              </div>
            </div>
          </div>
          <div v-if="empresa.json_config.obs_produto === '1'">
            <label class="h6 mb-2" for="observacoes">Observações <span class="small text-muted font-weight-normal ml-1">(opcional)</span></label>
            <textarea class="form-control observacoes-produto" id="observacoes" rows="3" maxlength="100" placeholder="Exemplo: Retirar um ingrediente"
                      style="resize: none" v-model="itemEditar.observacao"></textarea>
          </div>
          <div class="font-weight-bold mt-4">
            <button class="btn btn-primary btn-block p-2 mb-3" @click="editarItem">
              <b>Editar - {{(itemEditar.valor * itemEditar.quantidade) | valor}}</b>
            </button>
            <button type="button" class="btn btn-block text-primary" @click="openModalProduto(false)">Cancelar</button>
          </div>
        </div>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import Loading from './Loading'
  import ModalBottom from './ModalBottom'
  import Quantidade from "./Quantidade";
  import Icon from "./Icon";
  import ProdutoConsumo from "./ProdutoConsumo";
  import ProdutoModoPedido from "./ProdutoModoPedido";
  import Carrosell from "./Carrosell";
  import Produto from "./Produto";

  export default {
    name: 'CSacola',
    props: ['opened', 'isComponent'],
    components: {Produto, Carrosell, ProdutoModoPedido, ProdutoConsumo, Icon, Quantidade, Loading, ModalBottom },
    data() {
      return {
        token: localStorage.getItem('token'),
        modalProduto: false,
        item: {},
        itemEditar: { quantidade: 0, observacao: '' },
        load: false,
        url: '',
        recomendados: []
      }
    },

    methods: {
      openModalProduto(p) {
        this.modalProduto = false;
        this.item = {};

        if (p) {
          this.item = p;
          this.itemEditar = {
            produto: p.produto,
            observacao: p.observacao,
            valor: p.valor,
            quantidade: p.quantidade,
            id_beneficio: p.id_beneficio
          };

          setTimeout(() => {
            this.modalProduto = true;
          }, 100);
        }
      },

      editarItem() {
        this.item.observacao = this.itemEditar.observacao;
        this.item.quantidade = this.itemEditar.quantidade;
        this.salvarSacola();
        this.openModalProduto(false);
      },

      removeItem(p) {
        this.$swal({
          text: 'Deseja realmente remover este produto ?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.dados.produtos = this.dados.produtos.filter(obj => obj !== p);
            this.salvarSacola();
          }
        });
      },

      salvarSacola() {
        this.$store.commit('setProdutosSacola', this.dados);
      },

      finalizarPedido() {
        this.$helpers.trackPixel(this, 'InitiateCheckout', this.empresa);
        this.$helpers.trackAnalytics("begin_checkout", {
          currency: "BRL",
          value: this.dados.total,
          items: this.dados.produtos.map(dados => {
            return {
              item_id: dados.produto.id_tabela_preco,
              item_name: dados.produto.nome_produto,
              quantity: dados.quantidade
            }
          })
        });

        this.$router.push(this.url + (this.token ? '/finalizar' : '/perfil/cadastro'));
      },

      goCategorias() {
        if (this.$route.meta.page === 'Categorias') {
          this.$emit('close');
          this.$helpers.focusrElement('search');

        } else {
          this.$router.push(this.url + '/categorias');
        }
      },

      getRecomendados() {
        let recomendados = this.$store.state.recomendados;

        if (recomendados.length) {
          this.fillRecomendadaos(recomendados);
          return;
        }

        const stRecomendados = sessionStorage.getItem('recomendados');

        if (stRecomendados) {
          recomendados = this.$helpers.parseJSONObject(stRecomendados);

          if (recomendados) {
            this.fillRecomendadaos(recomendados);
            return;
          }
        }

        this.$http.get(this.$store.state.base_url + 'recomendados', { params: { tipo_pedido: this.dados.tipo_pedido } })
          .then(response => {
            this.load = false;
            recomendados = response.data || [];
            this.$store.state.recomendados = recomendados;
            sessionStorage.setItem('recomendados', JSON.stringify(recomendados));
            this.fillRecomendadaos(recomendados);

          }, res => {
            this.load = false;
          });
      },

      fillRecomendadaos(recomendados) {
        const ids_sacola = this.dados.produtos.map(s => s.id_produto);
        this.recomendados = recomendados.filter(r => !ids_sacola.includes(r.id_produto));
      },

      selProduto(p) {
        this.$refs.sProduto.openProduto({ id: p.id_produto });
      }
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
      this.getRecomendados();
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      },

      dados() {
        return this.$store.state.sacola
      }
    },

    watch: {
      opened(val) {
        if (val && !this.dados.produtos || !this.dados.produtos.length) {
          this.$router.push(this.url + '/categorias');
        }
      }
    },

    created() {
      window.scrollTo(0,0);
      document.body.classList.remove("modal-open");
    },

    filters: {
      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      }
    }
  }

</script>
<style scoped>
  .sacola-item-acoes {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
  }

  .sacola-item-acoes button {
    font-size: 0.875rem;
    font-weight: 400;
  }

  .btn-enviar {
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 0.5rem
  }

  .container-sacola {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    padding: 84px 0 96px;
    overflow-y: auto;
    height: 100vh;
    z-index: 1040;
  }

  .container-produtos-sacola {
    padding: 0 15px 15px;
  }

  .sacola-restricoes {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
  }

  .sacola-restricoes:empty {
    display: none;
  }

  .ios_platform .add-sacola {
    padding-bottom: 32px;
  }

  .container-sacola.opened {
    display: block;
  }

  .theme-2 .container-sacola {
    display: none;
  }

  @media (max-width: 767px) {
    .container-sacola {
      display: none;
    }
  }

  @media (min-width: 768px) {
    .container-produtos-sacola .card.bg-light {
      background-color: #fff !important;
      border: 1px solid #e3e6e9;
      box-shadow: none;
    }

    .container-sacola {
      width: 39%;
      top: 80px;
      right: 15px;
      padding: 0 0 22px;
      height: auto;
      box-shadow: var(--shadow);
      z-index: 8;
      border-radius: 12px;
      margin-bottom: 32px;
    }

    .container-produtos-sacola {
      padding: 15px 15px 6px;
      height: calc(100vh - 276px);
      overflow: auto;
      border-bottom: 1px solid #e9e9e9;
      margin-bottom: 16px;
    }

    .btn-enviar {
      background-color: #ffffff;
      position: static;
      border-top: none;
      padding: 0 15px;
    }
  }

  @media (min-width: 1200px) {
    .container-sacola {
      width: 28%;
    }
  }
</style>
